export enum IntegrationBaseResponseStatusNumEnum {
  SUCCESS = 0,
  INVALID_ARGUMENT = 1,
  ALREADY_EXIST = 2,
  NOT_AUTHORIZED = 3,
  NOT_FOUND = 4,
  UNPROCESSABLE_ENTITY = 5,
  OPERATION_FAILED = 6,
}
